import React from "react";
import { styled } from "goober";

import AddCard from "@/inline-assets/add-card.svg";
import ChevronRight from "@/inline-assets/chevron-right-button.svg";
import { DialogBody, DialogContent, DialogHeader } from "@/shared/Dialog.jsx";
import { ListTile } from "@/shared/ListTile.jsx";

export function AddPaymentMethodDialogView({
  onRequestAddCard,
  onRequestAddPayPal,
  onPressBack,
}: {
  onRequestAddCard(): void;
  onRequestAddPayPal(): void;
  onPressBack?: () => void;
}) {
  return (
    <DialogContent>
      <DialogHeader
        title={["common:wallet.addPaymentMethod", "Add Payment Method"]}
        onPressBack={onPressBack}
      />

      <DialogBody className="no-gutters">
        <PaymentMethodList>
          <li>
            <ListTile
              Leading={<AddCard />}
              Following={<ChevronRight />}
              title={[
                "common:wallet.addPaymentMethod.creditCard.title",
                "Credit Card",
              ]}
              subtitle={[
                "common:wallet.addPaymentMethod.creditCard.subtitle",
                "Add a card",
              ]}
              onClick={onRequestAddCard}
            />
          </li>

          <li>
            <ListTile
              Leading={<AddCard />}
              Following={<ChevronRight />}
              title={["common:wallet.addPaymentMethod.paypal.title", "PayPal"]}
              subtitle={[
                "common:wallet.addPaymentMethod.paypal.subtitle",
                "Connect your account",
              ]}
              onClick={onRequestAddPayPal}
            />
          </li>
        </PaymentMethodList>
      </DialogBody>
    </DialogContent>
  );
}

const PaymentMethodList = styled("ul")`
  display: flex;
  flex-direction: column;

  li {
    border-top: var(--sp-px) solid var(--shade1-15);

    list-style: none;

    .list-item {
      padding: var(--sp-4) var(--sp-6);
    }
  }
`;
